import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="light" className="titleBlock-align-left e-seal-key-feature-title" mdxType="TitleBlock" />
    <h2 {...{
      "id": "key-features-of-pdf-electronic-seal-api"
    }}>{`Key features of PDF Electronic Seal API`}</h2>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="align-left iocn-size  horizontal-align-heading e-seal-Benefits-one" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/e3c80a51c78c4cadcd89186b0dc6b0a0/e-seal_application_icon.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "electronic-seal-application"
    }}>{`Electronic seal application`}</h3>
    <p>{`Apply an electronic seal (e-seal) to PDF documents using a third-party digital certificate to verify the identity of the organization, to demonstrate the
authenticity  of the content, and show the timestamp of e-sealing.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="align-left iocn-size  link horizontal-align-heading linking
e-seal-Benefits-two" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/04283e3f96e2f70f5352699efa54b306/e-seal_verification_icon.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "e-seal-verification"
    }}>{`E-seal verification`}</h3>
    <p>{`Verify the e-seal electronically using Adobe Acrobat and view the relevant tamper-evident credentials.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="align-left iocn-size  link horizontal-align-heading linking e-seal-Benefits-three" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/8fa8ec7d03f0a98d25f691b24d7b5370/e-seal_eIDAS_compliance_icon.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "compliance-with-eidas"
    }}>{`Compliance with eIDAS`}</h3>
    <p>{`Use the API to apply "Simple" Electronic Seals, Advanced Electronic Seals (AdES) and Qualified Electronic Seals (QES) compliant with elDAS.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="align-left iocn-size  link horizontal-align-heading linking e-seal-Benefits-four" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/c0d0e083963d769f60a389a297e9297e/e-seal_REST_API_icon.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "platform-agnostic-rest-api"
    }}>{`Platform Agnostic REST API`}</h3>
    <p>{`E-seal documents easily at scale within end-to-end automated workflows. No hardware-based modules required.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="align-left iocn-size  link horizontal-align-heading linking e-seal-Benefits-five" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/d9525319934949d0a2dffac36693d8c7/eseal_Customizable_icon.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "customizable--easy-to-use"
    }}>{`Customizable & easy to use`}</h3>
    <p>{`The API allows you to upload a PDF document, provide a customized e-seal image, specify third-party digital certificate credentials, and provide the coordinates for a visual e-seal to be applied to the document.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="align-left iocn-size  link horizontal-align-heading linking e-seal-Benefits-six" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/a64c9bbe1e644003da77fb95d1985e8a/e-seal_TSP_Partnerships_icon.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "partnership-with-tsps"
    }}>{`Partnership with TSPs`}</h3>
    <p>{`The API supports certificates from certain TSPs (Trusted Service Provider) `}<a href="https://helpx.adobe.com/acrobat/kb/approved-trust-list1.html">{`AATL list (Adobe Approved Trust List)`}</a>{` that support OAuth authentication.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      